<template>
  <div>
    <base-header class="pb-6" type="primary">
      <breadcrumb-header :items="breadcrumb"></breadcrumb-header>
    </base-header>

    <div class="container-fluid mt--6">
      <table-navigation :table-title="tableTitle"
                        :table-buttons="tableButtons"
                        :table-columns="tableColumns"
                        :table-data="tableData"
                        :router-view="routerView"
                        :connection-error="connectionError"
                        :pagination="pagination"
                        :filter-options="filterOptions"
                        :filters="tableFilters"
                        @page="changePage"
                        @filters="changeFilters"
      >
      </table-navigation>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import TableNavigation from "@/views/Store/Tables/TableNavigation";
import BreadcrumbHeader from "@/views/Store/Layout/BreadcrumbHeader";

const {mapState, mapActions} = createNamespacedHelpers('BundleListModule')

export default {
  name: 'BundleList',
  components: {
    BreadcrumbHeader,
    TableNavigation,
  },
  data() {
    return {
      tableTitle: 'Lista zamówień hurtowych',
      routerView: 'bundle-view',
      tableButtons: [],
      tableColumns: [
        {
          prop: 'number',
          label: 'Numer',
          minWidth: 60,
          sortable: true,
          link: true,
        },
        {
          prop: 'date',
          label: 'Data',
          minWidth: 60,
          sortable: true,
        },
        {
          prop: 'partner',
          label: 'Partner',
          minWidth: 140,
          sortable: true,
        },
        {
          prop: 'total',
          label: 'Kwota',
          minWidth: 60,
          sortable: false,
        },
        {
          prop: 'status',
          label: 'Status',
          minWidth: 60,
          sortable: false,
        },
      ],
      filterOptions: [
        {field: 'number', label: 'Numer'},
        {field: 'partner.company', label: 'Partner'},
        {field: 'partner.fullName', label: 'Pełna nazwa partnera'},
        {field: 'status', label: 'Status'},
      ],
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.items,
      totalItems: state => state.totalItems,
      tableFilters: state => state.filterValues,
      connectionError: state => state.apiConnectionErr
    }),
    breadcrumb() {
      return [
        {title: 'Zamówienia', link: {name: 'orders'}},
        {title: 'Hurtowe'},
      ];
    },
    handleError() {
      return `Błąd ${this.connectionError.status} - ${this.$t[this.connectionError.status]}`;
    },
    pagination() {
      return {
        totalItems: this.totalItems,
        perPage: 20,
        currentPage: parseInt(this.$route.params.pageNum || 1),
      };
    },
  },
  methods: {
    changePage(page) {
      this.$router.push({name: 'bundle-list', params: {pageNum: page}});
    },
    changeFilters(filters) {
      this.$store.commit('BundleListModule/setFilterValues', filters);
      this.$store.dispatch('BundleListModule/fetchList', {
        token: this.$store.state.Auth.token,
        page: 1,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('BundleListModule/resetItems', []);
    return next()
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit('BundleListModule/resetItems', []);
    this.$store.dispatch('BundleListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: to.params.pageNum || 1,
    });
    return next();
  },
  beforeCreate() {
    this.$store.dispatch('BundleListModule/fetchList', {
      token: this.$store.state.Auth.token,
      page: this.$route.params.pageNum || 1,
    });
  },
};
</script>
